<template>
  <div>
    <b-row :style="{marginBottom: '18px'}">
      <b-col>
        <b-button class="float-right" variant="outline-primary" @click="exportWhole"><i class="fa fa-download" /> 导出</b-button>
      </b-col>
    </b-row>
    <b-table class="text-center" show-empty responsive="sm" :items="items" :fields="fields" :emptyText="tableEmptyText" />
    <b-pagination
      v-model="currentPage"
      :total-rows="totalRows"
      :per-page="perPage"
      prev-text="<<"
      next-text=">>"
      @change="changePage"
      hide-goto-end-buttons
      first-number
      last-number
    />
  </div>
</template>

<script>
import Error from '@/mixin/error'
import api from '@/utils/api'
import consts from '@/utils/consts'

export default {
  name: 'whole',
  mixins: [Error],
  props: ['appId', 'oversea'],
  data () {
    return {
      selectedDate: '',
      tableEmptyText: consts.TABLE_EMPTY_TEXT,
      fields: consts.VOTE_STATISTICS_FIELDS,
      items: [],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      tabName: '全局统计'
    }
  },
  created () {
    this.getStatistics()
  },
  methods: {
    getStatistics () {
      let params = {
        app_id: this.appId
      }
      api.fetchVoteListData(this, api.getVoteWholeStatistics(), 'whole_list', params, this.oversea ? consts.OVERSEA_TYPE : '')
    },
    changePage (page) {
      this.currentPage = page
      this.getStatistics()
    },
    exportWhole () {
      this.$emit('export', {
        path: api.getVoteWholeStatisticsExport(),
        tab: this.tabName
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// Whole.vue?4a1195a8